// startup
// Load entry module
__webpack_require__("./node_modules/@babel/polyfill/lib/index.js");
__webpack_require__("./wp-theme/src/js/app.js");
// This entry module used 'exports' so it can't be inlined
__webpack_require__("./wp-theme/src/js/video-captions.js");
__webpack_require__("./wp-theme/src/sass/style.scss");
